


















































































































































































import { get } from 'lodash';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

import EventBus from '../../../eventBus.js';

export default {
    name: 'CoTopNavBarMobile',
    components: {
        CoThumbnail,
        CoRoundButton,
        CoDropdown,
        CoDropdownItem,
        CoHeadline,
        CoText,
        CoIcon,
        CoConfirmation,
    },
    props: {
        logo: {
            type: String,
            default: '',
            required: false,
        },
        spaceName: {
            type: String,
            default: '',
            required: false,
        },
        userProfilePicture: {
            type: String,
            default: '',
            required: false,
        },
        supportURL: {
            type: String,
            default: null,
        },
        showUpgradeBar: {
            type: Boolean,
            default: false,
            required: false,
        },
        isAdmin: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            loading: true,

            newMessagesCount: 0,
            newNotificationsCount: 0,
            isBookingOn: get(this.$store, 'state.space.BookingOn', false),
        };
    },
    computed: {
        // Keep event-only profile shortcuts out of the mobile menu when events are disabled.
        isEventsEnabled() {
            if (this.$store && this.$store.state && this.$store.state.space) {
                return !this.$store.state.space.EventsOff;
            }
            return true;
        },
        // PagesOff removes member-facing page shortcuts on mobile.
        isPagesEnabled() {
            return !this.$store?.state?.space?.PagesOff;
        },
        isHomePath() {
            const path = this.$route['path'];
            if (path === '' || path === '/') return true;
            const matchPatterns = [
                /^\/account/,
                /^\/booking-calendar$/,
                /^\/channels$/,
                /^\/community/,
                /^\/event/,
                /^\/profile/,
                /^\/market/,
                /^\/jobs$/,
                /^\/messenger/,
                /^\/notification/,
            ];
            return matchPatterns.some((regex) => regex.test(path));
        },
    },
    watch: {
        showUpgradeBar(val) {
            if (val) {
                // update --header-height var value
                const root = document.documentElement;
                root.style.setProperty('--header-height', '5.75rem');
            } else {
                const root = document.documentElement;
                root.style.setProperty('--header-height', '4.25rem');
            }
        },
        '$store.state.space.ID': function refreshNotificationsOnSpaceChange(newVal, oldVal) {
            if (oldVal && newVal && newVal !== oldVal) {
                // Refresh badge counts when the mobile app switches to another community.
                this.getNewNotifications();
            }
        },
    },
    mounted() {
        // subscribe to new messages and new notifications events
        EventBus.$on(
            `NEWMESSAGES`,
            (count) => {
                this.newMessagesCount = count;
            },
            this
        );
        EventBus.$on(
            `NEWNOTIFICATIONS`,
            (count) => {
                this.newNotificationsCount = count;
            },
            this
        );

        this.getNewNotifications();
        this.getNewMessages();

        if (this.showUpgradeBar) {
            // update --header-height var value
            const root = document.documentElement;
            root.style.setProperty('--header-height', '5.75rem');
        } else {
            const root = document.documentElement;
            root.style.setProperty('--header-height', '4.25rem');
        }
    },
    methods: {
        showUpgradeModal() {
            // if admin show modal
            if (this.isAdmin) {
                this.$refs['remove-badge'].show();
            } else {
                // else redirect to coapp landing page
                window.open(
                    'https://www.coapp.io?utm_source=in-app&utm_medium=in-app&utm_campaign=powered-by',
                    '_blank'
                );
            }
        },
        goToUpgrade() {
            this.$router.push('/admin/account');
        },
        // opensupportURL function opens the support url in a new tab
        openSupportURL() {
            if (!this.supportURL) return;
            window.open(this.supportURL, '_blank');
        },
        goToSearch() {
            this.$router.push('/search/v2');
        },
        goToFeed() {
            this.$router.push('/');
        },
        // back function emitts a go back event
        back() {
            this.$emit('goBack');
        },

        // logout function emitts a logout event
        logout() {
            this.$emit('logout');
        },

        // showPauseNotificationsModal function emitts a show pause notifications modal event
        showPauseNotificationsModal() {
            this.$emit('showPauseNotificationsModal');
        },

        getNewNotifications() {
            if (!this.$store) {
                return;
            }
            this.$store
                .dispatch('getGetNewNotifications')
                .then((response) => {}, this)
                .catch((error) => {});
        },
        getNewMessages() {
            if (!this.$store) {
                return;
            }
            this.$store
                .dispatch('getNewMessagesNumbers', null)
                .then((response) => {}, this)
                .catch((error) => {});
        },
    },
};
